export default __webpack_public_path__ + "static/media/2106-00.1f0d03c2.jpg";